import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius } from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

/** Figma Info header — white card, top radius, subtle drop shadow. */
export const HeaderRoot = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${spacing[2]};
  padding: ${spacing[2]} ${spacing[3]};
  background-color: ${rawColors.structural.white};
  border-bottom: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.xl} ${borderRadius.xl} 0 0;
  box-shadow: 0 2px 6px 0 rgba(89, 98, 112, 0.15);
`;

export const HeaderMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[1]};
  min-width: 0;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
`;

export const LogoTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;

export const Logo = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const LeadingIconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${rawColors.text.mediumEmphasis};
`;

export const Title = styled.h2`
  margin: 0;
  ${typographyMixin("body", 2)}
  color: ${rawColors.text.highEmphasis};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ExternalLinkButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${rawColors.primary[500]};
  text-decoration: none;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const CloseButton = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  width: 16px;
  height: 16px;
  color: ${rawColors.text.mediumEmphasis};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: color 0.15s ease;

  &:hover {
    color: ${rawColors.text.highEmphasis};
  }

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[400]};
    outline-offset: 2px;
    border-radius: ${borderRadius.xs};
  }
`;

export const Subtitle = styled.p`
  margin: 0;
  ${typographyMixin("overline", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;
